



























import {Vue, Component} from 'vue-property-decorator'
import {Action, State} from 'vuex-class'
import {ProfileState} from '@/store/modules/profile'
import {Subscription} from '@/lib/kepler/interfaces'
import moment from 'moment'

import VuetifyColorHelper from '@/lib/vuetify/VuetifyColorHelper'
import Utils from '@/utils'

@Component({
  components: {
    FilteredListWithAddButton: Utils.loadComponent('FilteredListWithAddButton'),
    CheckBox: Utils.loadComponent('proxy/Inputs/CheckBox'),
    Flex: Utils.loadComponent('proxy/Flex'),
    CardSubscription: Utils.loadComponent('subscriptions/CardSubscription'),
  },
  name: 'MySubscriptions',
})
export default class MySubscriptions extends Vue {
  @State('profile') public profileState!: ProfileState
  @Action('getSubscriptions') public getSubscriptions: any

  private showExpired: boolean = false

  private get subscriptions() {
    if (this.showExpired) {
      return this.profileState.subscriptions || null
    } else {
      return this.profileState.subscriptions?.filter((sub) => {
        return this.isActive(sub)
      }) || null
    }
  }

  private color(c: string) {
    return VuetifyColorHelper.color(c)
  }

  private mounted() {
    this.getSubscriptions()
  }

  private openPlansPage() {
    this.$router.push({name: 'plans'})
  }

  private isActive(s: Subscription) {
    const now = moment()
    const end = moment.unix(s.end_timestamp)
    return now.isBefore(end)
  }

  private action(s: Subscription) {
    if (this.isActive(s)) {
      this.$router.push({path: `/profile/subscriptions/${s.id}`})
    }
  }
}
